import { render } from "./PersonalDevelopmentPlanWrapper.vue?vue&type=template&id=c0eaf80e&lang=html"
import script from "./PersonalDevelopmentPlanWrapper.vue?vue&type=script&lang=js"
export * from "./PersonalDevelopmentPlanWrapper.vue?vue&type=script&lang=js"

import "./PersonalDevelopmentPlanWrapper.vue?vue&type=style&index=0&id=c0eaf80e&lang=css"
script.render = render

export default script